import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.function.bind.js";
import "core-js/modules/es6.object.assign.js";

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from "react";

function Shield(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.61 2.188c1.98 1.815 4.316 2.692 7.431 2.692.422 0 .746.312.746.72 0 .5 0 1 .033 1.533l.02.88c.09 4.858-.277 11.02-8.09 13.799l-.367.125-.26.063-.259-.063c-8.696-2.88-8.566-9.796-8.501-14.804.032-.532.032-1.033.032-1.534 0-.407.325-.72.746-.72 3.115 0 5.484-.845 7.431-2.691a.811.811 0 011.038 0zm-.516.878l-.082.076c-2.004 1.792-4.424 2.666-7.485 2.733l-.133.001-.007.698a14.7 14.7 0 01-.01.302l-.014.27-.012 1.207c-.005 1.683.046 2.692.213 3.854.607 4.212 2.686 7.046 7.2 8.643l.335.115.02.005.313-.107c3.346-1.192 5.362-3.064 6.423-5.602l.11-.275c.801-2.082.953-4.042.857-7.792l-.018-.351a17.614 17.614 0 01-.01-.36l-.007-.607-.142-.001c-3.007-.07-5.4-.943-7.424-2.695l-.127-.114zM14.901 9.5l.949.977-4.316 3.85a.78.78 0 01-.49.173h-.03a.655.655 0 01-.49-.23L8.35 12l1.04-.89 1.715 1.78 3.796-3.39z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Shield);
export default ForwardRef;